export type LeadDeliveryOutcomeTone = 'positive' | 'neutral' | 'warning' | 'danger';

export interface LeadDeliveryOutcomePresentation {
  badgeLabel: string;
  summary?: string;
  tone: LeadDeliveryOutcomeTone;
}

export function getLeadDeliveryOutcomePresentation(
  leadStatusName: string | undefined,
  deliveryOutcomeSummary?: string | null
): LeadDeliveryOutcomePresentation {
  const normalizedStatus = leadStatusName?.trim().toLowerCase();
  const summary = deliveryOutcomeSummary?.trim() || undefined;

  switch (normalizedStatus) {
    case 'delivered':
      return {
        badgeLabel: 'Delivered',
        tone: 'positive',
        summary,
      };
    case 'not posted':
      return {
        badgeLabel: 'Not Posted',
        tone: 'neutral',
        summary,
      };
    case 'processing':
      return {
        badgeLabel: 'Processing',
        tone: 'warning',
        summary,
      };
    case 'failed':
      return {
        badgeLabel: 'Failed',
        tone: 'danger',
        summary,
      };
    default:
      return {
        badgeLabel: leadStatusName?.trim() || 'Unknown',
        tone: 'neutral',
        summary,
      };
  }
}
